import { render, staticRenderFns } from "./Dialog_DiscountShop.vue?vue&type=template&id=a908a300&scoped=true&"
import script from "./Dialog_DiscountShop.vue?vue&type=script&lang=js&"
export * from "./Dialog_DiscountShop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a908a300",
  null
  
)

export default component.exports